import { API_BASE_URL } from "../../../environment";

export const EntityNotificationService = {
  fetchIntervals: async () => {
    const authHeader = localStorage.getItem("authCred");
    if (!authHeader) throw new Error("No auth header");
    const res = await fetch(`${API_BASE_URL}/interval/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${authHeader}`,
      },
    });
    if (!res.ok) throw new Error("Error fetching intervals");
    const data = await res.json();
    return data.results || [];
  },

  fetchNotificationTypes: async () => {
    const authHeader = localStorage.getItem("authCred");
    if (!authHeader) throw new Error("No auth header");
    const res = await fetch(`${API_BASE_URL}/entity-notification-type/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${authHeader}`,
      },
    });
    if (!res.ok) throw new Error("Error fetching notification types");
    const data = await res.json();
    return data.results || [];
  },

  fetchEntityNotifications: async (tenantId: string, relatedEntityName: string) => {
    const authHeader = localStorage.getItem("authCred");
    if (!authHeader) throw new Error("No auth header");
    const res = await fetch(
      `${API_BASE_URL}/entity-notification/?tenant_id=${tenantId}&related_entity_name=${relatedEntityName}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${authHeader}`,
        },
      }
    );
    if (!res.ok) throw new Error("Error fetching entity notifications");
    const data = await res.json();
    return data.results || [];
  },

  createEntityNotification: async (payload: any) => {
    const authHeader = localStorage.getItem("authCred");
    if (!authHeader) throw new Error("No auth header");
    const res = await fetch(`${API_BASE_URL}/entity-notification/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${authHeader}`,
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to create notification");
    return res.json();
  },

  updateEntityNotification: async (id: number | string, payload: any) => {
    const authHeader = localStorage.getItem("authCred");
    if (!authHeader) throw new Error("No auth header");
    const res = await fetch(`${API_BASE_URL}/entity-notification/${id}/`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${authHeader}`,
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Failed to update notification");
    return res.json();
  },

  deleteEntityNotification: async (id: number | string) => {
    const authHeader = localStorage.getItem("authCred");
    if (!authHeader) throw new Error("No auth header");
    const res = await fetch(`${API_BASE_URL}/entity-notification/${id}/`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${authHeader}`,
      },
    });
    if (!res.ok) throw new Error("Failed to delete notification");
    return true;
  }
};
